export default "<div\nclassName=\"HelloWorld\"\ntitle={`You are visitor number ${num}`}\nonMouseOver={onMouseOver}\n>\n    hello world\n</div>"